/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationCondition } from './AutomationCondition';
import {
    AutomationConditionFromJSON,
    AutomationConditionFromJSONTyped,
    AutomationConditionToJSON,
    AutomationConditionToJSONTyped,
} from './AutomationCondition';
import type { AutomationActionConfig } from './AutomationActionConfig';
import {
    AutomationActionConfigFromJSON,
    AutomationActionConfigFromJSONTyped,
    AutomationActionConfigToJSON,
    AutomationActionConfigToJSONTyped,
} from './AutomationActionConfig';

/**
 * 
 * @export
 * @interface CreateAutomationRuleRequest
 */
export interface CreateAutomationRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAutomationRuleRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAutomationRuleRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAutomationRuleRequest
     */
    triggerType: CreateAutomationRuleRequestTriggerTypeEnum;
    /**
     * 
     * @type {Array<AutomationCondition>}
     * @memberof CreateAutomationRuleRequest
     */
    conditions?: Array<AutomationCondition>;
    /**
     * 
     * @type {string}
     * @memberof CreateAutomationRuleRequest
     */
    actionType: CreateAutomationRuleRequestActionTypeEnum;
    /**
     * 
     * @type {AutomationActionConfig}
     * @memberof CreateAutomationRuleRequest
     */
    actionConfig: AutomationActionConfig;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAutomationRuleRequest
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const CreateAutomationRuleRequestTriggerTypeEnum = {
    ClaimCreated: 'claim_created'
} as const;
export type CreateAutomationRuleRequestTriggerTypeEnum = typeof CreateAutomationRuleRequestTriggerTypeEnum[keyof typeof CreateAutomationRuleRequestTriggerTypeEnum];

/**
 * @export
 */
export const CreateAutomationRuleRequestActionTypeEnum = {
    SendForm: 'send_form'
} as const;
export type CreateAutomationRuleRequestActionTypeEnum = typeof CreateAutomationRuleRequestActionTypeEnum[keyof typeof CreateAutomationRuleRequestActionTypeEnum];


/**
 * Check if a given object implements the CreateAutomationRuleRequest interface.
 */
export function instanceOfCreateAutomationRuleRequest(value: object): value is CreateAutomationRuleRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('triggerType' in value) || value['triggerType'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('actionConfig' in value) || value['actionConfig'] === undefined) return false;
    return true;
}

export function CreateAutomationRuleRequestFromJSON(json: any): CreateAutomationRuleRequest {
    return CreateAutomationRuleRequestFromJSONTyped(json, false);
}

export function CreateAutomationRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAutomationRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'triggerType': json['triggerType'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(AutomationConditionFromJSON)),
        'actionType': json['actionType'],
        'actionConfig': AutomationActionConfigFromJSON(json['actionConfig']),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function CreateAutomationRuleRequestToJSON(json: any): CreateAutomationRuleRequest {
    return CreateAutomationRuleRequestToJSONTyped(json, false);
}

export function CreateAutomationRuleRequestToJSONTyped(value?: CreateAutomationRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'triggerType': value['triggerType'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(AutomationConditionToJSON)),
        'actionType': value['actionType'],
        'actionConfig': AutomationActionConfigToJSON(value['actionConfig']),
        'isActive': value['isActive'],
    };
}

